import { APP_INITIALIZER, Injector } from '@angular/core';
import { AJSService, AuthService } from '@app/core/services';
import { SOCKETS_HUBNAME, SOCKETS_URL } from '@common/constants';
import { logLevel } from './shared/sockets/core/lib/enums';
import { LinqSocketsService } from './shared/sockets/services';
import { DocManagement, IsGlobalAdmin, ReadOnly, WithReadOnly } from './utils/claims';

/**
 * Starts the AngularJS Bootstrapping
 * Ensures that AngularJS is loaded before Angular can load
 */
const AJS_INTIALIZER = {
	provide: APP_INITIALIZER,
	/**
	 * AnuglarJS Animate requires us to bootstrap at the document or body level
	 */
	useFactory: (ajsService: AJSService) => async (): Promise<any> => ajsService.bootstrap(document),
	deps: [AJSService],
	multi: true,
};

/**
 * Ensures that authentication is complete before Angular can load
 */
const AUTH_INITIALIZER = {
	provide: APP_INITIALIZER,
	useFactory: (authService: AuthService) => (): Promise<boolean> => authService.initialize(),
	deps: [AuthService],
	multi: true,
};

/**
 * Registers listener to start/stop socket connection
 */
const SOCKETS_INITIALIZER = {
	provide: APP_INITIALIZER,
	useFactory: (authService: AuthService, linqSocketsService: LinqSocketsService) => async (): Promise<void> => {
		authService.authentication$.subscribe((authentication) => {
			if (authentication.userId) {
				linqSocketsService.startConnection(SOCKETS_URL, SOCKETS_HUBNAME, authentication.userId, {
					logLevel: logLevel.warning,
					reconnectAttempts: -1,
				});
			} else {
				linqSocketsService.stopConnection();
			}
		});
	},
	deps: [AuthService, LinqSocketsService],
	multi: true,
};

/**
 * Adds injector to decorators
 */
const DECORATORS_INITIALIZER = {
	provide: APP_INITIALIZER,
	useFactory: (injector: Injector) => async (): Promise<void> => {
		WithReadOnly.injector = injector;
		ReadOnly.injector = injector;
		IsGlobalAdmin.injector = injector;
		DocManagement.injector = injector;
	},
	deps: [Injector],
	multi: true,
};

export { AJS_INTIALIZER, AUTH_INITIALIZER, DECORATORS_INITIALIZER, SOCKETS_INITIALIZER };
